import { type } from 'os';
import { ActionExtended } from '../../../_common/interfaces/ActionExtended';
import { ACTIONS } from '../../../_config'

export interface CompanyReducer {
  companyList: any;
}

const initialState: CompanyReducer = {
  companyList: null,
};

const companyReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.COMPANY.GET_COMPANY_LIST:
      return {
        ...state,
        companyList: action.payload.companyList,
      };
    default:
      return state;
  }
};

export default companyReducer;
